<section class="pdf-shell panel" [class.full-bleed]="fullBleedMode" [class.embedded-mode]="!showControls"
  [class.drag-active]="dragActive" [class.uploading]="uploading" (dblclick)="onViewerDoubleClick()"
  (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
  <header class="pdf-toolbar">
    <div [class.viewer-meta-hidden]="pdfUrl && !showControls">
      <h2>Schematic</h2>
    </div>
    @if (pdfUrl && showControls) {
    <div class="pdf-controls">
      <button type="button" class="secondary" (click)="previousPage()" [disabled]="currentPage() <= 1">Prev</button>
      <span>Page {{ currentPage() }} / {{ totalPages || 1 }}</span>
      <button type="button" class="secondary" (click)="nextPage()"
        [disabled]="currentPage() >= totalPages">Next</button>
      <button type="button" class="secondary" (click)="zoomOut()">-</button>
      <span>Zoom {{ (zoom * 100) | number:'1.0-0' }}%</span>
      <button type="button" class="secondary" (click)="zoomIn()">+</button>
      <button type="button" class="secondary" (click)="resetZoom()">Reset</button>
    </div>
    }
  </header>

  @if (pdfUrl) {
  <div class="pdf-debug">
    @if (showControls) {
    <span>State: {{ loadingState }}</span>
    }
    @if (uploading) {
    <span>Uploading: {{ selectedFileName || 'PDF' }}</span>
    }
    @if (loadingState === 'loading') {
    <span>Progress: {{ progressPct }}%</span>
    }
    @if (showControls && totalPages > 0) {
    <span>Pages: {{ renderedPages }}/{{ totalPages }}</span>
    }
    @if (searchMatches > 0) {
    <span>Matches: {{ searchMatches }}</span>
    }
  </div>
  }

  @if (lastError) {
  <p class="pdf-error">{{ lastError }}</p>
  }

  @if (pdfUrl) {
  <div class="pdf-viewer-wrap">
    @if (showPopoutButton) {
    <button type="button" class="secondary floating-popout-btn" (click)="requestPopout()">Pop out</button>
    }
    @if (pdfSourceData) {
    <pdf-viewer [src]="pdfSourceData" [page]="currentPage()" [render-text]="true" [render-text-mode]="1"
      [show-all]="false" [original-size]="false" [fit-to-page]="true" [autoresize]="true" [show-borders]="true"
      [zoom-scale]="showControls ? 'page-width' : 'page-fit'" [zoom]="zoom" (after-load-complete)="onPdfLoaded($event)"
      (page-rendered)="onPageRendered()" (text-layer-rendered)="onTextLayerRendered()"
      (on-progress)="onLoadProgress($event)" (error)="onPdfError($event)">
    </pdf-viewer>
    }
  </div>
  } @else {
  <div class="empty-state">
    <p>Drag and drop a PDF here</p>
    <small>Max size: {{ formatBytes(maxFileSizeBytes) }}</small>
    @if (selectedFileName) {
    <small>Selected: {{ selectedFileName }}</small>
    }
  </div>
  }

</section>